<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/Quiz Live Dashboard</span>
        </v-row>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span><h3>Quiz Live Dashboard</h3></span>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col xs="12" sm="12" lg="3" xl="2" md="12" cols="12"> <span>academic Year : </span> <label>{{ay}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="2" md="12" cols="12"> <span>Semester : </span> <label>{{sem}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="2" md="12" cols="12"> <span>Course : </span> <label>{{course}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="2" md="12" cols="12"> <span>Program : </span> <label>{{program}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Year : </span> <label>{{year}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Division : </span> <label>{{division}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Exam : </span> <label>{{examassessmenttype}}</label> </v-col>
                    <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Quiz Title : </span> <label>{{quiz}}</label> </v-col>

                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">Student Data<v-spacer></v-spacer>
            <span class="refresh">Refresh Live data</span>
             <v-icon class="reload" @click="refreshTable">mdi-refresh-circle</v-icon> </v-card-title>
            <template>
                <v-data-table :search="search1" :headers="newHeaders" :items="examlearnerlist" :expanded.sync="expanded" :single-expand="singleExpand" item-key="srno">
                    <template v-slot:top>
                        <v-toolbar flat>
                             <v-text-field v-model="search1"  label="Search"  class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>
                             <v-spacer></v-spacer>
                            <download-excel class="mar ml-5" :data="examlearnerlist" :fields="exam_learner_list" worksheet="exam_learner_list" name="StudentData.xls">
                                <v-btn color="success" dark class="mb-2">
                                    Export<v-icon dark>mdi-file-excel</v-icon>
                                </v-btn>
                            </download-excel>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.log="{ item }">
                        <i class="mdi mdi-eye eye" style="text-align: center; color: #5cbbf6; font-size: 30px;" @click="viewAllPhoto(item)"></i>
                    </template>
                </v-data-table>
            </template>
        </v-card>
        <v-row justify="center">
            <v-dialog v-model="dialog_allPhoto" persistent max-width="1500px">  
                <v-card>
                    <v-toolbar class="all-pic">
                        <v-spacer></v-spacer>
                        Quiz Response
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon dark @click="dialog_allPhoto = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>      
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-row>
                        <v-col xs="12" sm="12" lg="1" xl="2" md="12" cols="12"></v-col>
                        <v-col xs="12" sm="12" lg="4" xl="2" md="12" cols="12"> <span>academic Year : </span> <label>{{ay}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="3" xl="2" md="12" cols="12"> <span>Semester : </span> <label>{{sem}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="4" xl="2" md="12" cols="12"> <span>Course : </span> <label>{{course}}</label> </v-col>
                    </v-row>    
                    <v-row>
                        <v-col xs="12" sm="12" lg="1" xl="2" md="12" cols="12"></v-col>
                        <v-col xs="12" sm="12" lg="4" xl="2" md="12" cols="12"> <span>Program : </span> <label>{{program}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Year : </span> <label>{{year}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="4" xl="4" md="12" cols="12"> <span>Division : </span> <label>{{division}}</label> </v-col>
                    </v-row>
                    <v-row>  
                        <v-col xs="12" sm="12" lg="1" xl="2" md="12" cols="12"></v-col>  
                        <v-col xs="12" sm="12" lg="4" xl="4" md="12" cols="12"> <span>Student Name : </span> <label>{{student}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="3" xl="4" md="12" cols="12"> <span>Exam : </span> <label>{{examassessmenttype}}</label> </v-col>
                        <v-col xs="12" sm="12" lg="4" xl="4" md="12" cols="12"> <span>Quiz Title : </span> <label>{{quiz}}</label> </v-col>

                    </v-row>
                    <br>
                    <br>
                    <v-row justify="center">
                        <v-data-table :headers="headers1" :items="quizresponselist" :search="search" disable-pagination="true" item-key="srno">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-text-field v-model="search1"  label="Search"  class="pt-4"></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-spacer></v-spacer>
                                    <download-excel class="mar ml-5" :data="quizresponselist" :fields="exam_learner_list" worksheet="exam_learner_list" name="QuizResponse.xls">
                                        <v-btn color="success" dark class="mb-2">
                                            Export<v-icon dark>mdi-file-excel</v-icon>
                                        </v-btn>
                                    </download-excel>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.is_correct="{ item }">
                                <v-icon v-if="item.is_correct==false"
                                size="25"
                                color="red darken-3"
                                class="mr-2"
                                >mdi-window-close</v-icon
                              >  
                              <v-icon v-else size="25" class="mr-2" color="rgb(1, 127, 152)">mdi-check</v-icon>                          
                            </template>
                        </v-data-table>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    export default {
        data: () => ({
            dialog_zooimg: false,
            img_url: "",
            chatIcon: true,
            chatFlag: false,
            allstudent: null,
            student: null,
            arr: [],
            msg: "",
            newHeaders: [
                { text: "SrNo", value: "srno" },
                { text: "Student Name", value: "studname" },
                { text: "Student Start Time", value: "started_at" },
                { text: "Student End Time", value: "exam_end_time" },
                { text: "Division", value: "division" },
                { text: "Marks Obtained", value: "marks" },
                { text: "View Answers", value: "log" },
            ],

            headers1: [
                { text: "Sr.No", value: "srno" },
                { text: "Quiz Type", value: "questiontype" },
                { text: "Question", value: "question" },
                { text: "Selected Option", value: "select_option" },
                { text: "Correct Option", value: "correct_option" },
                { text: "Is Correct", value: "is_correct" },
                { text: "Marks", value: "marks" },
                { text: "Co No", value: "cono" },
            ],
            proctor_id: null,
            examlearnerlist: [],
            learnerlist: null,
            exam_status_list: null,
            proctor_status_list: null,
            exam: null,
            starttime: null,
            student:null,
            endtime: null,
            extratime: null,
            examstatuslist: null,
            examdate: null,
            proctoringthreshold: null,
            examstatus: "",
            quizresponselist: "",
            dialog_allPhoto: false,
            color: "",
            snackbar: false,
            snackbar_msg: "",
            search: "",
            search1: "",
            meeting_url_dialog: false,
            meeting_url: null,
            show_url: null,
            edit_URL_dialog: false,
            new_url: null,
            photo_url: null,
            dialog_photo: false,
            dialog_chat: false,
            stud_name: null,
            gr_no:null,
            program : null,
            year: null,
            ay:null,
            sem:null,
            program:null,
            division:null,
            examassessmenttype:null,
            quiz:null,
        }),
        mounted() {
            if (this.$store.getters.proctor_session_id == null) {
                this.$router.push({ name: "quiz-student-response" });
            } else {
                this.proctor_id = this.$store.getters.proctor_session_id;
                this.onLoad();
            }
            this.chat_box = window.innerHeight - 60;
            this.chat_div = this.chat_box - 110;
            //this.chat_data.flag = false;
        },
        methods: {
            refreshTable() {
                //alert("Reload Table")
                this.onLoad();
            },
            viewAllPhoto(item) {
                const formData = {
                    lesid: item.id,
                    proctor_id: this.$store.getters.proctor_session_id,
                };
                axios
                    .post("QuizDashboard/quizresponsedata", formData)
                    .then((res) => {
                        if (res.data.msg == "success" && res.data.status == "200") {
                            this.quizresponselist = res.data.Exam_Result_List_Details;
                            this.dialog_allPhoto = true;
                            this.student = item.studname
                        } else {
                            this.loading4 = false;
                            this.showSnackbar("#b71c1c", "Student Quiz Response Not Found...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = false;
                    })
                    .finally(() => {
                        var loading4 = false;
                    });
            },
            onLoad() {
                //alert("onload")
                const formData = {
                    proctor_id: this.$store.getters.proctor_session_id,
                };
                axios
                    .post("QuizDashboard/QuizDashboardMonitoring", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //alert(res.data.stud_catlist)
                            if ((this.load = true)) {
                                this.exam_status_list = res.data.exam_status;
                                this.proctor_status_list = res.data.proctor_status;
                                this.examlearnerlist = res.data.lesummary_data;
                                this.learnerlist = res.data.lesummary_data;
                                this.arr = res.data.stud_catlist;
                                this.exam = res.data.exam;
                                this.starttime = res.data.starttime;
                                this.endtime = res.data.endtime;
                                this.examdate = res.data.examdate;
                                this.proctoringthreshold = res.data.proctoringthreshold;
                                this.ay = res.data.ay;
                                this.sem = res.data.sem;
                                this.course = res.data.course;
                                this.program = res.data.program;
                                this.year = res.data.year;
                                this.division=res.data.division;
                                this.examassessmenttype = res.data.examassessmenttype;
                                this.quiz = res.data.quiz
                                if(res.data.url == 'NA'){
                                    this.show_url = '';
                                } else{
                                    this.show_url = res.data.url;
                                }
                            }
                        } else if (res.data.msg == "No") {
                            this.showSnackbar("#b71c1c", "Students Not Alloted Yet...!");
                            return;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .refresh{
        font-size: 11px;
        font-weight: 500;
        padding-right: 5px;
    }
    .ex-text {
        font-weight: 500;
        margin-bottom: 0px;
    }
    .elevation-1 /deep/ thead th {
        background-color: #deeff5 !important;
        /* color: white !important; */
        /* white-space: nowrap !important; */
    }
    .reload {
        color: white;
    }
    span {
        font-weight: 900;
    }
    .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
    .m {
        margin-top: 1.5rem;
    }
    .flex {
        display: flex;
        justify-content: center;
        background: aliceblue;
        margin: 10px;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }
</style>
